export const FORGET_PASSWORD = "FORGET_PASSWORD"
export const FORGET_PASSWORD_SUCCESS = "FORGET_PASSWORD_SUCCESS"
export const FORGET_PASSWORD_ERROR = "FORGET_PASSWORD_ERROR"

export const RESET_PASSWORD = "RESET_PASSWORD"
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS"
export const RESET_PASSWORD_ERROR = "RESET_PASSWORD_ERROR"

export const VERIFY_EMAIL_ACCOUNT = "VERIFY_EMAIL_ACCOUNT"
export const VERIFY_EMAIL_ACCOUNT_SUCCESS = "VERIFY_EMAIL_ACCOUNT_SUCCESS"
export const VERIFY_EMAIL_ACCOUNT_ERROR = "VERIFY_EMAIL_ACCOUNT_ERROR"

export const POST_RESET_USER = "POST_RESET_USER"
export const POST_RESET_USER_SUCCESS = "POST_RESET_USER_SUCCESS"
export const POST_RESET_USER_FAIL = "POST_RESET_USER_FAIL"

export const POST_CHANGE_PASSWORD = "POST_CHANGE_PASSWORD"
export const POST_CHANGE_PASSWORD_SUCCESS = "POST_CHANGE_PASSWORD_SUCCESS"
export const POST_CHANGE_PASSWORD_FAIL = "POST_CHANGE_PASSWORD_FAIL"
